import { Customer } from '@/types';

export const CUSTOMER_SEARCH_PAGE_SIZE = 100;
export const MAX_CUSTOMER_SEARCH_PAGES = 200;

export const normalizeSearchText = (value: string) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const getCustomerLookupKey = (customer: Customer) =>
  customer.id || normalizeSearchText(customer.email);
